(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mouseout', 'mousemove', 'mousewheel', 'wheel', 'mouseup', 'mousedown', 'resize', 'pointerup', 'mouseleave', 'pointerdown'];

const targets = [window, Document, HTMLBodyElement, HTMLElement, HTMLDivElement];
(window as any).__Zone_ignore_on_properties = [];
targets.forEach(function (target) {
    (window as any).__Zone_ignore_on_properties.push({
        target: target,
        ignoreProperties: ['scroll']
    });
});
